import { useEffect } from "react";
import { useLocation } from 'react-router-dom';
import { Link } from 'react-router-dom';
import SEO, { SITE_NAME } from '../Components/SEO';
import ActivityFilter from "../Shared/activityFilter.jsx";
import activityData from "../Mainpages/Data/activitylist.jsx";
import "./Home.css";

const categoryCards = [
  {
    to: "/Topics/topics",
    title: "Lesson Plans",
    description: "Free lesson plans designed to cover 60 or 90 minutes.",
    icon: "🗂️",
    image: "/Images/online-teacher.webp",
    color: "#2A9D8F",
    tag: "Curriculum",
    tagClass: "tag-strategy",
    level: "60 – 90 Minutes",
    rating: "⭐ 4.9",
    resourceCount: "📁 48 Resource Decks",
    cta: "Access Materials",
  },
  {
    to: "/grammar-exercises",
    title: "Language Points",
    description: "Jump straight to grammar explanations and exercises to go with.",
    icon: "📝",
    image: "/Images/grammar1.webp",
    color: "#2A9D8F",
    tag: "Structure",
    tagClass: "tag-grammar",
    level: "All Levels",
    rating: "⭐ 4.7",
    resourceCount: "📁 32 Diagnostic Tools",
    cta: "Access Materials",
  },
  {
    to: "/vocabulary-exercises",
    title: "Vocabulary",
    description: "Flashcards and quizzes. Really effective to learn new words fast.",
    icon: "📚",
    image: "/Images/1person2.webp",
    color: "#2A9D8F",
    tag: "Linguistics",
    tagClass: "tag-vocab",
    level: "Thematic Sets",
    rating: "⭐ 4.8",
    resourceCount: "📁 1,200 Terms",
    cta: "Access Materials",
  },
  {
    to: "/reading-exercises",
    title: "Reading",
    description: "Real world articles sorted by level.",
    icon: "📖",
    image: "/Images/2people1.webp",
    color: "#2A9D8F",
    tag: "Comprehension",
    tagClass: "tag-reading",
    level: "Case Analysis",
    rating: "⭐ 4.8",
    resourceCount: "📁 40 Reading Packs",
    cta: "Access Materials",
  },
  {
    to: "/speaking-exercises",
    title: "Speaking",
    description: "A compendium of speaking topics — questions and opinion statements — on various topics. This will keep students talking for hours.",
    icon: "🗣️",
    image: "/Images/2people2.webp",
    color: "#2A9D8F",
    tag: "Communication",
    tagClass: "tag-speech",
    level: "Fluency Workshops",
    rating: "⭐ 5.0",
    resourceCount: "📁 15 Presentation Guides",
    cta: "Access Materials",
  },
  {
    to: "/videos",
    title: "Videos",
    description: "Interesting and informative videos from TED talks and across the net. Students always have something to say about these.",
    icon: "🎥",
    image: "/Images/3people1a.webp",
    color: "#2A9D8F",
    tag: "Media Lectures",
    tagClass: "tag-video",
    level: "Immersive Video",
    rating: "⭐ 4.9",
    resourceCount: "📁 24 Case Studies",
    cta: "Access Materials",
  },
];

const CategoryCard = ({
  to,
  title,
  description,
  image,
  tag,
  tagClass,
  level,
  rating,
  resourceCount,
  cta,
}) => {
  return (
    <Link to={to} className="category-card-link">
      <article className="lms-card">
        <div className="image-wrapper">
          {image && (
            <img src={image} alt={title} loading="lazy" />
          )}
          {tag && (
            <span className={`lms-tag ${tagClass}`}>{tag}</span>
          )}
        </div>
        <div className="lms-body">
          <div className="meta-row">
            <span className="difficulty">{level}</span>
            <span className="rating">{rating}</span>
          </div>
          <h3 className="lms-title">{title}</h3>
          <p className="lms-desc">{description}</p>
          <div className="lms-footer">
            <span className="resource-count">{resourceCount}</span>
            <span className="lms-link">
              {cta}
              <svg
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2.5"
                strokeLinecap="round"
                strokeLinejoin="round"
                aria-hidden="true"
              >
                <line x1="5" y1="12" x2="19" y2="12"></line>
                <polyline points="12 5 19 12 12 19"></polyline>
              </svg>
            </span>
          </div>
        </div>
      </article>
    </Link>
  );
};

const Home = ({ setFilters = () => {} }) => {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const element = document.querySelector(location.hash);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }, [location]);

  return (
    <div className="home-page">
      <SEO
        title="Free English Lesson Plans and Practice Materials"
        description="Free English practice materials, exercises and lesson plans for teachers and students. Practise grammar, reading, writing, speaking, vocabulary and exam-style English online for free."
        name={SITE_NAME}
        type="article"
      />
      <div className="home-container">
        <div className="homebodytext">
          <h2>Free English Lesson Plans and Materials for <strong>Online English Teachers</strong></h2>
          <h5>Resources for teachers teaching English <strong>one-on-one</strong> and <strong>groups</strong> English lessons.</h5>
        </div>

        <section className="category-cards" aria-label="Browse by category">
          <div className="category-cards__header">
            <h2>What will you practice today?</h2>
            <p>Choose a skill to practice with your students or do a whole lesson</p>
          </div>
          <div className="category-cards__grid">
            {categoryCards.map((card) => (
              <CategoryCard key={card.to} {...card} />
            ))}
          </div>
        </section>

        {/*  <div id="filter">
          <ActivityFilter
            data={activityData}
            resultsLabel="activities"
            itemsPerPage={6}
          />
        </div> */}
      </div>
    </div>
  );
};

export default Home;